export const techAndMeasureTagTooltips = {
  investementExpenditure: [
    {
      value: null,
      text: '无需投资支出'
    },
    {
      value: '$',
      text: '建议的措施或技术意味着投入支出低于1万美元'
    },
    {
      value: '$$',
      text: '建议的措施或技术意味着投入支出高于1万美元但低于15万美元'
    },
    {
      value: '$$$',
      text: '建议的措施或技术意味着投入支出高于15万美元但低于50万美元'
    },
    {
      value: '$$$$',
      text: '建议的措施或技术意味着投入支出高于50万美元'
    }
  ],
  impactEnergy: [
    {
      value: '低',
      text: '节省等于或低于15%'
    },
    {
      value: '中等',
      text: '节省介于16-30%'
    },
    {
      value: '高',
      text: '节省介于31-60%'
    },
    {
      value: '很高',
      text: '节省高于60%'
    }
  ],
  impactWater: [
    {
      value: '低',
      text: '节省等于或低于15%'
    },
    {
      value: '中等',
      text: '节省介于16-30%'
    },
    {
      value: '高',
      text: '节省介于31-60%'
    },
    {
      value: '很高',
      text: '节省高于60%'
    }
  ]
};
